import { useCallback, useEffect, useRef } from 'react';

const HISTORY_STATE_KEY = 'exportDrawer';

export const useDrawerBackButton = (isOpen: boolean, onClose: () => void, onOpen: () => void) => {
  const historyPushedRef = useRef(false);

  useEffect(() => {
    if (isOpen && !historyPushedRef.current) {
      window.history.pushState({ [HISTORY_STATE_KEY]: true }, '');
      historyPushedRef.current = true;
    }

    if (!isOpen && historyPushedRef.current) {
      historyPushedRef.current = false;
      if (window.history.state?.[HISTORY_STATE_KEY]) {
        window.history.back();
      }
    }
  }, [isOpen]);

  const handlePopState = useCallback(() => {
    if (window.history.state?.[HISTORY_STATE_KEY]) {
      historyPushedRef.current = true;
      onOpen();
    } else if (historyPushedRef.current) {
      historyPushedRef.current = false;
      onClose();
    }
  }, [onClose, onOpen]);

  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [handlePopState]);
};
